import { render, staticRenderFns } from "./PacienteListagemTabela.vue?vue&type=template&id=3d92ba94&scoped=true"
import script from "./PacienteListagemTabela.vue?vue&type=script&lang=js"
export * from "./PacienteListagemTabela.vue?vue&type=script&lang=js"
import style0 from "./PacienteListagemTabela.vue?vue&type=style&index=0&id=3d92ba94&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d92ba94",
  null
  
)

export default component.exports